document.addEventListener('DOMContentLoaded', function () {
    const statItems = document.querySelectorAll('.sst-hero__stat-value');

    const animateValue = (obj, start, end, duration, prefix, suffix) => {
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            const value = Math.floor(progress * (end - start) + start);
            obj.innerHTML = prefix + value.toLocaleString() + suffix;
            if (progress < 1) {
                window.requestAnimationFrame(step);
            } else {
                obj.innerHTML = prefix + end.toLocaleString() + suffix;
            }
        };
        window.requestAnimationFrame(step);
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const el = entry.target;
                const rawValue = el.getAttribute('data-value');

                // Parse the value: e.g., "99%", "100k+", "$500"
                // Simple regex to separate prefix, number, suffix
                // Matches: (non-digits)(digits)(non-digits)
                // This is basic and might need adjustment for complex cases
                const match = rawValue.match(/^([^0-9]*)([0-9,]+)(.*)$/);

                if (match) {
                    const prefix = match[1] || '';
                    const numberStr = match[2].replace(/,/g, ''); // Remove commas for parsing
                    const number = parseInt(numberStr, 10);
                    const suffix = match[3] || '';

                    if (!isNaN(number)) {
                        animateValue(el, 0, number, 2000, prefix, suffix);
                    }
                }

                observer.unobserve(el);
            }
        });
    }, { threshold: 0.5 });

    statItems.forEach(item => {
        observer.observe(item);
    });
});
